import { JourneyHub, JourneyIssue, JourneyIssueKind } from '@addmile/backend-client';

import { INFO_SELECTION, Selection } from './selection';

export interface DescribedIssue {
  label: string;
  target: Selection;
}

// Issues come from the last save, so they name nodes by the saved journey's ids and positions.
export const describeIssue = (issue: JourneyIssue, journey: JourneyHub): DescribedIssue => {
  const mileIndex = journey.miles.findIndex((mile) => mile.id === issue.mileId);
  const mile = journey.miles[mileIndex];
  const stepIndex = mile?.steps.findIndex((step) => step.id === issue.stepId) ?? -1;
  const mileLabel = `Mile ${mileIndex + 1}`;
  const stepLabel = `Step ${mileIndex + 1}.${stepIndex + 1}`;
  const mileTarget: Selection = { kind: 'mile', mileKey: issue.mileId ?? '' };
  const stepTarget: Selection = {
    kind: 'step',
    mileKey: issue.mileId ?? '',
    stepKey: issue.stepId ?? '',
  };

  switch (issue.kind) {
    case JourneyIssueKind.TitleMissing:
      return { label: 'Journey has no title', target: INFO_SELECTION };
    case JourneyIssueKind.ImageMissing:
      return { label: 'Journey has no cover image', target: INFO_SELECTION };
    case JourneyIssueKind.ShortDescriptionMissing:
      return { label: 'Journey has no short description', target: INFO_SELECTION };
    case JourneyIssueKind.NoMiles:
      return { label: 'Journey has no miles', target: INFO_SELECTION };
    case JourneyIssueKind.JourneyCompleteEmpty:
      return { label: 'Journey complete has no content', target: { kind: 'journeyComplete' } };
    case JourneyIssueKind.MileTitleMissing:
      return { label: `${mileLabel} has no title`, target: mileTarget };
    case JourneyIssueKind.NoSteps:
      return { label: `${mileLabel} has no steps`, target: mileTarget };
    case JourneyIssueKind.MileCompleteEmpty:
      return {
        label: `${mileLabel} complete has no content`,
        target: { kind: 'mileComplete', mileKey: issue.mileId ?? '' },
      };
    case JourneyIssueKind.StepTitleMissing:
      return { label: `${stepLabel} has no title`, target: stepTarget };
    case JourneyIssueKind.NoBlocks:
      return { label: `${stepLabel} has no blocks`, target: stepTarget };
    case JourneyIssueKind.CheckInEmpty:
      return {
        label: `${stepLabel} · Check-in is empty`,
        target: { ...stepTarget, kind: 'block', blockKey: issue.stepBlockId ?? '' },
      };
    default:
      return { label: issue.kind, target: INFO_SELECTION };
  }
};
